import * as React from 'react';
const SvgDelivery = (props) => (
  <svg viewBox="0 0 124 104" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.359 78.371v-10.97c0-4.22 2.509-8.228 6.48-9.916l11.29-4.641a5.332 5.332 0 0 0 3.136-4.852c-3.763-4.009-3.972-11.182-3.972-18.355 0-6.54 5.226-11.814 11.707-11.814 6.48 0 11.707 5.274 11.707 11.814 0 6.962-.209 14.346-3.972 18.355a5.332 5.332 0 0 0 3.136 4.852l11.29 4.641c3.971 1.688 6.48 5.485 6.48 9.916v10.97"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path d="M122 2H2v76.371h120V2Z" stroke="#000" strokeWidth={4} strokeMiterlimit={10} />
    <path
      d="M122 78.371H2V88.92h120V78.37ZM62 102V88.92M30.641 102H93.36"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgDelivery;
